'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _momentWithLocales = require('moment/min/moment-with-locales');

var _momentWithLocales2 = _interopRequireDefault(_momentWithLocales);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _datetimeFormatter = require('./datetime-formatter');

var _datetimeFormatter2 = _interopRequireDefault(_datetimeFormatter);

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var DATE_FORMAT = 'DD/MM';
var DATE_FORMAT_FULL = 'DD/MM/YYYY';
var DATE_FORMAT_ISO = 'YYYY-MM-DD';
var DATE_FORMAT_PRETTY = 'DD MMMM';
var TIME_FORMAT = 'HH:mm';
var DATE_TIME_FORMAT = DATE_FORMAT_FULL + ' ' + TIME_FORMAT;
var DATE_TIME_FORMAT_SHORT = DATE_FORMAT + ' ' + TIME_FORMAT;
var SLOT_LENGTH = 15;

function extractDay(date) {
  var dateFormat = date.length === 4 ? DATE_FORMAT : DATE_FORMAT_FULL;
  var value = _momentWithLocales2.default.utc(date, dateFormat).day();
  return value === 0 ? 6 : value - 1;
}

function dateFromSlotTime(date, slotTime) {
  var forceUTC = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var timeComponents = slotTime.split(':');
  if (!forceUTC) {
    return date.hours(timeComponents[0]).minutes(timeComponents[1]);
  }
  return _momentWithLocales2.default.utc(date).hours(timeComponents[0]).minutes(timeComponents[1]);
}

function deliveryDayData(times, date) {
  var n = extractDay(date);
  return _lodash2.default.find(times, { day: n });
}

function deliveryTimesForSlot(slot, current) {
  var min = SLOT_LENGTH;

  var currentDateTime = current ? _momentWithLocales2.default.utc(current, DATE_TIME_FORMAT) : _momentWithLocales2.default.utc();

  var start = dateFromSlotTime(currentDateTime.clone(), slot.open);
  var end = dateFromSlotTime(currentDateTime.clone(), slot.close);
  var times = {};
  while (end.diff(start, 'minutes') > 0) {
    if (start.isAfter(currentDateTime) || start.isSame(currentDateTime)) {
      times[start.format(TIME_FORMAT)] = start.format(TIME_FORMAT);
    }
    start.add(min, 'minutes');
  }
  return times;
}

function parseOrCurrentDate(current) {
  if (!current) {
    return _momentWithLocales2.default.utc();
  }

  var dateFormat = current.indexOf('-') > -1 ? DATE_FORMAT_ISO : DATE_TIME_FORMAT;
  return _momentWithLocales2.default.utc(current, dateFormat);
}

function deliveryTimesData(offset, data, date) {
  var today = !date ? _momentWithLocales2.default.utc() : _momentWithLocales2.default.utc(date, DATE_TIME_FORMAT);
  var tomorrow = !date ? _momentWithLocales2.default.utc() : _momentWithLocales2.default.utc(date, DATE_TIME_FORMAT);
  var days = {};

  var todayTimes = deliveryDayData(data, today.clone());

  if (!todayTimes) return days;

  tomorrow.add(1, 'day').hour(0).minute(0);
  today.add(offset, 'minutes');

  var valuesToday = _lodash2.default.map(todayTimes.slots, function (slot) {
    return deliveryTimesForSlot(slot, today.clone().format(DATE_TIME_FORMAT));
  });
  var valuesTodayMerged = Object.assign.apply(Object, [{}].concat(_toConsumableArray(valuesToday)));
  if (Object.keys(valuesTodayMerged).length > 0) {
    days[today.format(DATE_FORMAT_FULL)] = Object.assign.apply(Object, [{}].concat(_toConsumableArray(valuesToday)));
  }

  var tomorrowTimes = deliveryDayData(data, tomorrow);
  if (tomorrowTimes && tomorrowTimes.open) {
    var valuesTomorrow = _lodash2.default.map(tomorrowTimes.slots, function (slot) {
      return deliveryTimesForSlot(slot, _lodash2.default.clone(tomorrow).format(DATE_TIME_FORMAT));
    });
    days[tomorrow.format(DATE_FORMAT_FULL)] = Object.assign.apply(Object, [{}].concat(_toConsumableArray(valuesTomorrow)));
  }
  return days;
}

function addAsapToDeliveryTimes(deliveryTimes, ASAP_LABEL) {
  var today = deliveryTimes[0];
  return [{
    label: today.label,
    value: today.value,
    values: _extends(_defineProperty({}, ASAP_LABEL, _constants.DELIVERY_TIME_ASAP), today.values)
  }, deliveryTimes[1]];
}

function isAfterLastSlot(current, todaySlots) {
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  if (todaySlots.length === 0) {
    return true;
  }

  // parse or extract current time
  var theDate = !_momentWithLocales2.default.isMoment(current) ? _momentWithLocales2.default.utc(current, DATE_FORMAT + ' ' + TIME_FORMAT) : current;

  if (!theDate.isValid()) {
    throw new Error('Invalid current date. Valid format: ' + DATE_FORMAT + ' ' + TIME_FORMAT);
  }

  var last = dateFromSlotTime(theDate.clone(), todaySlots[todaySlots.length - 1].close, false);
  theDate.add(offset, 'minutes');

  if (theDate.isAfter(last)) {
    return true;
  }
  return false;
}

function localToday() {
  var dateFormat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DATE_FORMAT;

  return _momentWithLocales2.default.utc().local().format(dateFormat);
}

function extractUTCTime(date) {
  return _momentWithLocales2.default.utc(date).format(TIME_FORMAT);
}

function toLocalTime(date, time) {
  var isISO = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (time === _constants.DELIVERY_TIME_DEFAULT) {
    return _momentWithLocales2.default.utc().local().format(TIME_FORMAT);
  }

  var mDate = isISO ? _momentWithLocales2.default.utc(date) : _momentWithLocales2.default.utc(date, DATE_FORMAT);
  if (!time) {
    return mDate.local().format(TIME_FORMAT);
  }

  var timeComponents = time.split(':');
  if (timeComponents.length !== 2) {
    throw new Error('Time ' + time + ' is not a valid time. Format should be ' + TIME_FORMAT);
  }
  mDate.hour(timeComponents[0]);
  mDate.minutes(timeComponents[1]);

  return mDate.local().format(TIME_FORMAT);
}

function toUTCTime(time) {
  if (time === _constants.DELIVERY_TIME_DEFAULT) {
    return _momentWithLocales2.default.utc().format(TIME_FORMAT);
  }
  return _momentWithLocales2.default.utc(time, TIME_FORMAT).format(TIME_FORMAT);
}

function toUTCFullDate(date) {
  if (date === _constants.DELIVERY_DATE_DEFAULT) {
    return _momentWithLocales2.default.utc().format(DATE_FORMAT_FULL);
  }
  return _momentWithLocales2.default.utc(date, DATE_FORMAT).format(DATE_FORMAT_FULL);
}

function formatISO(date) {
  if (_momentWithLocales2.default.isMoment(date)) {
    return date.format(DATE_FORMAT_ISO);
  }

  return _momentWithLocales2.default.utc(date, DATE_FORMAT_FULL).format(DATE_FORMAT_ISO);
}

function splitISO(date) {
  var parsed = _momentWithLocales2.default.utc(date);
  return {
    date: parsed.format(DATE_FORMAT_FULL),
    time: parsed.format(TIME_FORMAT)
  };
}

function toLocalDate(date, locale) {
  var dateFormat = date.indexOf('-') > -1 ? DATE_FORMAT_ISO : DATE_FORMAT;
  var outputFormat = locale ? DATE_FORMAT_PRETTY : DATE_FORMAT;
  return _momentWithLocales2.default.utc(date, dateFormat).locale(locale).format(outputFormat);
}

function toLocalHumanDate(date, locale) {
  return _momentWithLocales2.default.utc(date).local().locale(locale).format('LL');
}

function toHumanDate(date, locale) {
  var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'LL';
  var timeFormat = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : TIME_FORMAT;

  return _momentWithLocales2.default.utc(date).locale(locale).format(format + ' ' + timeFormat);
}

function toHumanCalendar(date, locale) {
  return _momentWithLocales2.default.utc(date).locale(locale).calendar();
}

function isFuture(date, locale) {
  return !_momentWithLocales2.default.utc(date).locale(locale).isBefore(_momentWithLocales2.default.utc().locale(locale), 'day');
}

function isDeliveryAvailableToday(slots, offset, current) {
  var currentDate = !current ? _momentWithLocales2.default.utc() : current;
  var today = deliveryDayData(slots, currentDate);
  if (!today.open || isAfterLastSlot(currentDate, today.slots, offset)) {
    return false;
  }

  return true;
}

function isDeliveryAvailableTomorrow(slots, current) {
  var currentDate = parseOrCurrentDate(current);
  currentDate.add(1, 'days');
  var tomorrow = deliveryDayData(slots, currentDate);

  if (!tomorrow.open || tomorrow.slots.length === 0) {
    return false;
  }

  return true;
}

function nextDeliveryTimeToday(offset, days, current) {
  var currentDate = parseOrCurrentDate(current);
  var data = deliveryTimesData(offset, days, currentDate);
  var date = Object.keys(data)[0];
  if (!date) {
    return null;
  }
  var timeUTC = Object.keys(data[date])[0];
  var timeLocal = data[date][timeUTC];
  return {
    date: date,
    time: timeLocal
  };
}

function isOpenToday(times, current) {
  var currentDate = parseOrCurrentDate(current);
  var data = deliveryDayData(times, currentDate);
  return data && data.open && !isAfterLastSlot(currentDate, data.slots);
}

function nextXDaysRange(days, start) {
  var current = parseOrCurrentDate(start);
  return [current.format(DATE_FORMAT_ISO), current.add(days, 'days').format(DATE_FORMAT_ISO)];
}

function nextWeekRange(start) {
  return nextXDaysRange(7, start);
}

function nextTwoWeeksRange(start) {
  return nextXDaysRange(14, start);
}

function weekDayLocale(date, locale) {
  var dateFormat = date.indexOf('-') > -1 ? DATE_FORMAT_ISO : DATE_FORMAT_FULL;
  var mDate = _momentWithLocales2.default.utc(date, dateFormat);
  var val = locale === 'en-US' ? mDate.format('dddd') : mDate.locale(locale).format('dddd');
  return val[0].toUpperCase() + val.substring(1);
}

function weekDayLocaleByIndex(index) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';

  return (0, _momentWithLocales2.default)().locale(locale).isoWeekday(index).format('dddd').toString();
}

function isDateExpired(date, toCheck) {
  var current = parseOrCurrentDate(toCheck);
  return current.isAfter(_momentWithLocales2.default.utc(date), 'minute');
}

function areDatesEqual(dateISO, toCheck) {
  var date1 = _momentWithLocales2.default.utc(dateISO).startOf('day');
  var date2 = parseOrCurrentDate(toCheck).startOf('day');
  return date1.isSame(date2, 'hour');
}

function now() {
  var full = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var date = _momentWithLocales2.default.utc().local();
  return full ? date.format(DATE_TIME_FORMAT) : date.format(TIME_FORMAT);
}

function isDatePastNow(dateISO) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var nowDateLocal = (0, _momentWithLocales2.default)().local().seconds(0);
  var nowDateFakeUTC = _momentWithLocales2.default.utc().hours(nowDateLocal.hours()).minutes(nowDateLocal.minutes()).seconds(0);
  return _momentWithLocales2.default.utc(dateISO).add(offset, 'minutes').isAfter(nowDateFakeUTC);
}

// compare 2 (absolute) times with format hh:mm
// returns
//        -1 if t1<t2
//        0 if t1==t2
//        1 if t1>t2
function compareTimes(t1, t2) {
  var d1 = dateFromSlotTime(_momentWithLocales2.default.utc(), t1);
  var d2 = dateFromSlotTime(_momentWithLocales2.default.utc(), t2);
  if (d1.isAfter(d2, 'minute')) {
    return 1;
  }

  if (d1.isSame(d2, 'minute')) {
    return 0;
  }

  return -1;
}

/*
  changing time/date values (ISO) without
  switch timezone to local withouth
 */
function switchTimeZoneToLocal(date, time) {
  var parsedDate = _momentWithLocales2.default.utc(date + ' ' + time, DATE_TIME_FORMAT);
  var offset = parsedDate.clone().local().utcOffset();
  return parsedDate.subtract(offset, 'minutes').format();
}

function currentTimeInSlot(slots, offset, dateTime) {
  var current = !dateTime ? (0, _momentWithLocales2.default)().local() : parseOrCurrentDate(dateTime);
  var data = deliveryDayData(slots, current);
  if (data.slots.length === 0) {
    return false;
  }

  return _lodash2.default.some(data.slots, function (slot) {
    var openParts = slot.open.split(':');
    var closeParts = slot.close.split(':');
    var open = current.clone().hours(openParts[0]).minutes(openParts[1]);

    if (offset) {
      open.subtract(offset, 'minutes');
    }
    var close = current.clone().hours(closeParts[0]).minutes(closeParts[1]);
    return (current.isAfter(open) || current.isSame(open)) && (current.isBefore(close) || current.isSame(close));
  });
}

// fromISO and toISO are REAL utc dates in ISO string format
function currentDateInRange(_ref) {
  var fromISO = _ref.fromISO,
      toISO = _ref.toISO;
  var today = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var current = !today ? (0, _momentWithLocales2.default)().local() : _momentWithLocales2.default.utc(today);
  return current.isBetween(fromISO, toISO, 'minute') || current.isSame(fromISO, 'minute') || current.isSame(toISO, 'minute');
}

// fromISO and toISO are REAL utc dates in ISO string format
function currentDateIsBefore(toISO) {
  var today = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var current = !today ? (0, _momentWithLocales2.default)().local() : _momentWithLocales2.default.utc(today);
  return current.isBefore(toISO, 'minute') || current.isSame(toISO, 'minute');
}

function mapTimesToHumanTimes(offset, times, localeConstants) {
  var useISODate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (!times) {
    return [];
  }
  var preparedData = deliveryTimesData(offset, times, now(true));
  var today = localToday(DATE_FORMAT_FULL);
  return _lodash2.default.map(Object.keys(preparedData), function (key) {
    return {
      label: today === key ? localeConstants.TODAY : localeConstants.TOMORROW,
      value: useISODate ? (0, _momentWithLocales2.default)(key, DATE_FORMAT_FULL).format(DATE_FORMAT_ISO) : key,
      values: preparedData[key]
    };
  });
}

function supportLocale(lang) {
  return (_momentWithLocales2.default.locales() || []).indexOf(lang) > -1;
}

exports.default = {
  deliveryTimesData: deliveryTimesData,
  deliveryTimesForSlot: deliveryTimesForSlot,
  extractDay: extractDay,
  isAfterLastSlot: isAfterLastSlot,
  isFuture: isFuture,
  toLocalTime: toLocalTime,
  localToday: localToday,
  toUTCTime: toUTCTime,
  toUTCFullDate: toUTCFullDate,
  toHumanDate: toHumanDate,
  toHumanCalendar: toHumanCalendar,
  isDatePastNow: isDatePastNow,
  formatISO: formatISO,
  isDeliveryAvailableToday: isDeliveryAvailableToday,
  isDeliveryAvailableTomorrow: isDeliveryAvailableTomorrow,
  nextDeliveryTimeToday: nextDeliveryTimeToday,
  isOpenToday: isOpenToday,
  nextXDaysRange: nextXDaysRange,
  nextWeekRange: nextWeekRange,
  nextTwoWeeksRange: nextTwoWeeksRange,
  weekDayLocale: weekDayLocale,
  weekDayLocaleByIndex: weekDayLocaleByIndex,
  toLocalDate: toLocalDate,
  isDateExpired: isDateExpired,
  areDatesEqual: areDatesEqual,
  extractUTCTime: extractUTCTime,
  now: now,
  compareTimes: compareTimes,
  toLocalHumanDate: toLocalHumanDate,
  switchTimeZoneToLocal: switchTimeZoneToLocal,
  currentTimeInSlot: currentTimeInSlot,
  currentDateInRange: currentDateInRange,
  currentDateIsBefore: currentDateIsBefore,
  splitISO: splitISO,
  mapTimesToHumanTimes: mapTimesToHumanTimes,
  addAsapToDeliveryTimes: addAsapToDeliveryTimes,
  supportLocale: supportLocale,
  DATE_FORMAT: DATE_FORMAT,
  DATE_FORMAT_PRETTY: DATE_FORMAT_PRETTY,
  TIME_FORMAT: TIME_FORMAT
};


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-frontend-lib/lib/helpers/time.js
// module id = 20
// module chunks = 0